import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ThemeProvider } from "@/ThemeContext";
import LandingPage from "@/pages/LandingPage";
import AdminDashboard from "@/pages/AdminDashboard";
import ClientDashboard from "@/pages/ClientDashboard";
import ResetPassword from "@/pages/ResetPassword";
import CampaignDashboard from "@/pages/CampaignDashboard";
import AuthCallback from "@/pages/AuthCallback";
import AnniversaryRSVP from "@/pages/AnniversaryRSVP";
import PublicGallery from "@/pages/PublicGallery";

function AppRouter() {
  const location = useLocation();
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  // Check URL fragment for session_id synchronously during render (before routes)
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<Navigate to="/?login=true" replace />} />
      <Route path="/admin" element={<Navigate to="/?login=true" replace />} />
      <Route path="/admin/dashboard" element={<AdminDashboard />} />
      <Route path="/portal" element={<Navigate to="/?login=true" replace />} />
      <Route path="/portal/dashboard" element={<ClientDashboard />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/anniversary-party" element={<AnniversaryRSVP />} />
      <Route path="/gallery/:slug" element={<PublicGallery />} />
      <Route path="/campaigns/:campaignId" element={<CampaignDashboard />} />
      <Route path="/campaigns/view" element={<CampaignDashboard />} />
    </Routes>
  );
}

function App() {
  return (
    <ThemeProvider>
      <div className="App">
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </div>
    </ThemeProvider>
  );
}

export default App;
